import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormLabel,
  Grid,
  Input,
  InputGroup,
  InputRightAddon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { color } from "../../../utils/theme";
import Indicator from "../../../components/indicator";
import Title from "../../../components/Title/";
import { fetchIndicators } from "../../../redux/action/";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store/";
import { RootState } from "../../../redux/reducer/rootReducer";
import {
  indicatorDataType,
  Indicator as IndicatorType,
} from "../../../redux/reducer/indicatorsReducer";
import IndicatorDetail from "../../../components/indicatordetail";
import FormInput from "../../../components/input";
import Select from "react-select";
import { Option } from "../../../utils/types/props.dropdown";
const Indicators = () => {
  const [openIndicatorDetail, setOpenIndicatorDetail] = useState(false);
  const [, setDataEntryModal] = useState(false);
  const [selectedIndicator, setSelectedIndicator] = useState("");
  const [indicatorDataType, setIndicatorDataType] =
    useState<indicatorDataType>();
  const [selctedIndicatorDetail, setSelctedIndicatorDetail] =
    useState<IndicatorType>();
  const { id, name } = useParams<{ id: string; name: string }>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [dataEntryPercentage, setDataEntryPercentage] = useState("");
  const [dataEntryNumerator, setDataEntryNumerator] = useState("");
  const [dataEntryDenominator, setSetDataEntryDenominator] = useState("");
  const [dataEntryNumber, setDataEntryNumber] = useState("");
  const [dataEntryLoading, setDataEntryLoading] = useState(false);
  const [dataEntryData, setDataEntryDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  let scales: Option[] = [
    {
      value: "Excellent",
      label: "Excellent",
    },
    { value: "Very Good", label: "Very Good" },
    { value: "Good", label: "Good" },
    { value: "Fair", label: "Fair" },
  ];
  const [selectedScale, setSelectedScale] = useState("");
  const navigate = useNavigate();
  const toast = useToast();

  const dispatch: AppDispatch = useDispatch();
  const indicators = useSelector((state: RootState) => state.indicators.data);

  const handleEnterDataClicked = (dataType: indicatorDataType) => {
    setDataEntryModal(true);
    setIndicatorDataType(dataType);
    onOpen();
  };

  const closeDataEntryModal = () => {
    setDataEntryNumerator("");
    setDataEntryNumber("");
    setSetDataEntryDenominator("");
    setSelectedScale("");
    setDataEntryPercentage("");
    setIndicatorDataType("");
    setDataEntryLoading(false);
    onClose();
  };
  useEffect(() => {
    dispatch(fetchIndicators(parseInt(id ?? "")));
  }, [dispatch]);

  return (
    <>
      {openIndicatorDetail && (
        <Drawer
          size={"md"}
          isOpen={openIndicatorDetail}
          placement="right"
          onClose={() => setOpenIndicatorDetail(false)}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader w={"90%"} style={{ textAlign: "left", fontSize: 18 }}>
              {selectedIndicator}
            </DrawerHeader>

            <DrawerBody>
              <IndicatorDetail
                indicator={selctedIndicatorDetail as IndicatorType}
              />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add {indicatorDataType} Data</ModalHeader>
          <ModalCloseButton onClick={closeDataEntryModal} />
          <ModalBody>
            <FormInput
              name="dataEntryData"
              isRequired={true}
              value={dataEntryData}
              label="Date"
              type="date"
              id="name"
              errorMessage={""}
              onChange={(event) => {
                setDataEntryDate(event.target.value);
              }}
            />
            {indicatorDataType === "Ratio" && (
              <>
                <FormInput
                  name="numerator"
                  isRequired={true}
                  value={dataEntryNumerator}
                  label="Enter Numerator"
                  type="number"
                  id="numerator"
                  errorMessage={""}
                  onChange={(event) => {
                    setDataEntryNumerator(event.target.value);
                  }}
                />
                <FormInput
                  name="denominator"
                  isRequired={true}
                  value={dataEntryDenominator}
                  label="Enter Denominator"
                  type="text"
                  id="denominator"
                  errorMessage={""}
                  onChange={(event) => {
                    setSetDataEntryDenominator(event.target.value);
                  }}
                />
              </>
            )}
            {indicatorDataType === "Percentage" && (
              <>
                <FormLabel
                  display={"flex"}
                  mb={0}
                  fontWeight={"500"}
                  color={color.text}
                >
                  Percentage
                  <Text color={"red"} mx={1} fontSize={24}>
                    *
                  </Text>
                </FormLabel>
                <InputGroup size="sm">
                  <Input
                    placeholder=""
                    value={dataEntryPercentage}
                    onChange={(event) => {
                      setDataEntryPercentage(event.target.value);
                    }}
                    type="number"
                    name="percentage"
                    required
                  />
                  <InputRightAddon>%</InputRightAddon>
                </InputGroup>
              </>
            )}
            {indicatorDataType === "Number" && (
              <>
                <FormInput
                  name="number"
                  isRequired={true}
                  value={dataEntryNumber}
                  label="Enter Number"
                  type="text"
                  id="number"
                  onChange={(event) => {
                    setDataEntryNumber(event.target.value);
                  }}
                />
              </>
            )}

            {indicatorDataType === "Scale" && (
              <>
                <FormControl style={{ width: "100%" }}>
                  <FormLabel
                    display={"flex"}
                    mb={0}
                    fontWeight={"500"}
                    color={color.text}
                  >
                    Scale
                    <Text color={"red"} mx={1} fontSize={24}>
                      *
                    </Text>
                  </FormLabel>

                  <Select
                    placeholder=" "
                    options={scales}
                    onChange={(event) => {
                      setSelectedScale(event?.value as string);
                    }}
                  />
                  <Text
                    marginY={3}
                    fontWeight={"normal"}
                    color={"red"}
                    fontSize={13}
                  >
                    {selectedScale === "" && "Scales are required."}
                  </Text>
                </FormControl>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              isLoading={dataEntryLoading}
              colorScheme={
                (indicatorDataType === "Number" && dataEntryNumber === "") ||
                (indicatorDataType === "Percentage" &&
                  dataEntryPercentage === "") ||
                (indicatorDataType === "Ratio" &&
                  dataEntryDenominator === "" &&
                  dataEntryNumerator === "") ||
                (indicatorDataType === "Scale" && selectedScale === "")
                  ? "gray"
                  : "blue"
              }
              color={
                (indicatorDataType === "Number" && dataEntryNumber === "") ||
                (indicatorDataType === "Percentage" &&
                  dataEntryPercentage === "") ||
                (indicatorDataType === "Ratio" &&
                  dataEntryDenominator === "" &&
                  dataEntryNumerator === "") ||
                (indicatorDataType === "Scale" && selectedScale === "")
                  ? "gray"
                  : "white"
              }
              mr={3}
              onClick={async () => {
                setDataEntryLoading(true);
                setTimeout(() => {
                  closeDataEntryModal();
                  toast({
                    position: "top-right",
                    render: () => (
                      <Box color="white" p={3} bg="green">
                        Data Entered successfully!
                      </Box>
                    ),
                  });
                }, 2000);
              }}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Box
        display={"flex"}
        h={"90%"}
        w={"100%"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        alignContent={"center"}
        alignItems={"center"}
        textAlign={"left"}
      >
        <Grid
          w={"75%"}
          px={"auto"}
          justifyContent={"center"}
          templateColumns={["repeat(1, 1fr)"]}
          gap={[4]}
        >
          <Box style={{ gridColumn: "1 / -1" }}>
            <Title
              title={`${name}`}
              onClick={() => {
                navigate("/indicator-packages");
              }}
            />
          </Box>
          {indicators.map((item, index) => (
            <Indicator
              title={item.name}
              onClickModal={() => {
                handleEnterDataClicked(item.data_type);
              }}
              onInfoClick={() => {
                setOpenIndicatorDetail(true);
                setSelectedIndicator(item.name);
                setSelctedIndicatorDetail(item);
              }}
            />
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Indicators;
